import ImageBlobReduce from 'image-blob-reduce';
import { ENV } from '~/env';

type ResizeOptions = ImageBlobReduce.ResizeOptions;

export const resizeImage = async (file: File, options?: ResizeOptions) => {
  // Disable workers in development due to webpack bundling issues with pica's blob workers.
  // Production works fine with workers enabled (uses WASM for better performance).
  // Dev error: "ReferenceError: __webpack_require__ is not defined" in worker context
  // because webpack transforms pica's worker require() calls but worker lacks webpack runtime.
  const reducer = ENV.DEVELOPMENT
    ? new ImageBlobReduce({
        pica: ImageBlobReduce.pica({ features: ['js'] })
      })
    : new ImageBlobReduce();

  const dest = await reducer.toBlob(file, options);

  return new File([dest], file.name, {
    lastModified: file.lastModified,
    type: file.type,
  });
};
